export enum CursorState {
  Blinking = 'Blinking',
  Idle = 'Idle',
}
